import { CategoryScale, Chart as ChartJS, type ChartConfiguration, type ChartData } from 'chart.js';
import { Chart } from 'react-chartjs-2';

import { DeepResearchCard, DeepResearchCompContent, DeepResearchCompTitle } from './shared';

import type { StatisticalAnalysisAnswer } from '@/entities/ask-syncly/types';
ChartJS.register(CategoryScale);

export function Statistics({ title, content, charts }: StatisticalAnalysisAnswer) {
  return (
    <DeepResearchCard>
      <DeepResearchCompTitle>{title}</DeepResearchCompTitle>
      <DeepResearchCompContent className="mt-6">{content}</DeepResearchCompContent>
      <div className="mt-16 flex flex-col gap-2">
        {charts.map((chart) => (
          <StatisticsChart key={chart} chart={chart} />
        ))}
      </div>
    </DeepResearchCard>
  );
}

export function StatisticsChart({ chart }: { chart: string }) {
  const chartData = JSON.parse(chart);
  return (
    <Chart
      options={
        {
          aspectRatio: 1,
          responsive: true,
        } as ChartConfiguration['options']
      }
      type={chartData.type as keyof typeof ChartJS.register}
      data={chartData.data as ChartData<never, number[], string>}
    />
  );
}
